import React from 'react';
import './App.css';
import { connect } from 'react-redux';
import jsonContent from './content.json';
//Container imports
import Home from './containers/home'
import 'antd/dist/antd.css';
//Get page content
const Content = () => JSON.parse(JSON.stringify(jsonContent));
class App extends React.Component {
  componentDidMount(){
    this.getData(Content())
    console.log("Ehm")
    console.log(Content())
  }
  getData = (content) => {
    this.props.dispatch({
      type: 'GET_CONTENT',
      content: content
    }) 
  }
  render(){
    return (
      <div className="App">
        <Home />
        
      </div>
    );
  }
}

const mapStateToProps = (store) => ({
  Content: store.content
})
export default connect(mapStateToProps)(App);

